module.exports = __webpack_public_path__ + "img/story2-en.4e8d46ec.png";